/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.js';

function AlphabeticSort(a, b) {
  return a[0].localeCompare(b[0]);
}
var groupedByCategory = function groupedByCategory(items, customCategorySorting) {
  var result = items.reduce(function (groupedArray, currentItem) {
    var newResults = _objectSpread2({}, groupedArray);
    newResults[currentItem.category] = newResults[currentItem.category] || [];
    newResults[currentItem.category].push(currentItem);
    return newResults;
  }, Object.create(null));
  var finalResult = Object.keys(result).reduce(function (array, key) {
    var elementArr = [key, result[key]];
    array.push(elementArr);
    return array;
  }, []);
  var comparator = customCategorySorting || AlphabeticSort;
  finalResult.sort(comparator);
  return finalResult;
};

export { groupedByCategory as default, groupedByCategory };
